import { shadeColor } from 'common/js/colors';
import { FormatContext, ILoadingStrategy } from '../loading-strategy-factory';
import style from './redirect-root-style.scss';

export class RedirectStyleLoadingStrategy implements ILoadingStrategy {
  isRunnable(formatContext: any): boolean {
    return formatContext.context.creativeSource === 'redirect';
  }

  alterConfiguration(formatContext: FormatContext): FormatContext {
    return formatContext;
  }

  onBeforeRender(formatContext: FormatContext): void {
    this.setBackgroundColor(formatContext);
  }

  onAfterRender(formatContext: FormatContext): void {
    this.overrideRootDivClass(formatContext);
  }

  private overrideRootDivClass(formatContext: FormatContext): void {
    // For redirect format, in simpleInjection = false
    // the root element do not have the height style
    // This strategy is here to cope with legacy styling issue
    // where simpleInjection is now always to true

    document.querySelector('#root')?.classList.add(style.rootOverridingStyle);
    const { useSimpleInjection } = formatContext.config;
    document
      .querySelector('#format')
      ?.setAttribute(
        'style',
        `height: ${useSimpleInjection ? '100%' : 'auto'}`
      );
  }

  private setBackgroundColor(formatContext: FormatContext) {
    if (formatContext.config.backgroundTransparent) {
      return;
    }

    const {
      background: { primaryColor, secondaryColor, shade, useBackgroundShading }
    } = formatContext.config;

    let secondaryColorGradient = secondaryColor;
    if (useBackgroundShading) {
      secondaryColorGradient = shadeColor(primaryColor, shade);
    }

    document.body.style.background = `radial-gradient(${primaryColor}, ${secondaryColorGradient})`;
  }

  onResize(formatContext: FormatContext): void {}
}
